import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useMeQuery } from '../../queries/me';
import { useRecordTemplateUse } from '../../queries/templates';
import ThreadPanel from '../Inbox/ThreadPanel';

export default function Chat({ contact: c, onProfile }) {
  const { can } = useAuth();
  const { data: me } = useMeQuery();
  const [draft, setDraft] = useState('');
  const recordUse = useRecordTemplateUse();
  const canSend = can('manage_messages') && !(me?.sms && !me.sms.available);
  const insertTemplate = (template) => {
    setDraft((d) => (d.trim() ? `${d.trimEnd()} ${template.body}` : template.body));
    recordUse.mutate(template._id);
  };
  return (
    <div className="cp-chat">
      <ThreadPanel
        logOnly
        conversation={{ contactNumber: c.phone, name: c.name, type: c.type === 'applicant' ? 'prospect' : c.type, property: c.home }}
        canSend={canSend}
        draft={draft}
        onDraftChange={setDraft}
        onProfile={onProfile}
        onTemplatePick={insertTemplate}
      />
    </div>
  );
}
